// Cores do Assistente (2026-10-21): calculadas aqui em hex, sem color-mix()
// no CSS — o WebView de alguns Androids não entende color-mix e o cabeçalho
// ficava branco (print do usuário). Base = cor do assistente na
// Administração, senão a cor da empresa, senão verde.
import type { CSSProperties } from "react";

const FALLBACK = "#16a34a";

function parse(hex: string): [number, number, number] | null {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const n = parseInt(m[1]!, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

const toHex = (c: [number, number, number]) => `#${c.map((v) => Math.round(v).toString(16).padStart(2, "0")).join("")}`;
const mix = (a: [number, number, number], b: [number, number, number], t: number) =>
  toHex([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]);

export function aiPalette(color?: string | null): CSSProperties {
  const base = parse(color ?? "") ?? parse(FALLBACK)!;
  const black: [number, number, number] = [0, 0, 0];
  const white: [number, number, number] = [255, 255, 255];
  // Texto em cima da cor: branco, ou quase preto se a cor for muito clara (ex.: amarelo).
  const lum = (0.299 * base[0] + 0.587 * base[1] + 0.114 * base[2]) / 255;
  return {
    "--ai": toHex(base),
    "--ai-dark": mix(base, black, 0.3),
    "--ai-light": mix(base, white, 0.3),
    "--ai-soft": mix(base, white, 0.88),
    "--ai-softer": mix(base, white, 0.94),
    "--ai-border": mix(base, white, 0.7),
    "--ai-dot": mix(base, white, 0.78),
    "--ai-on": lum > 0.7 ? "#0f172a" : "#ffffff",
  } as CSSProperties;
}
